const booksdata = {

    "books":[{
        "id":1,
        "images":"https://cdn.asaha.com/assets/thumbs/653/653f249a58f438ef343c5da5f023203d.jpg",
        "Title":"Give and Take: WHY HELPING OTHERS DRIVES OUR SUCCESS",
        "Auther":"Adam Grant",
        "Rating":"9/10",
        
       },{
        "id":2,
        "images":"https://cdn.asaha.com/assets/thumbs/2b0/2b0d9a4f533872d9c6f68e6767da1ce8.jpg",
        "Title":"You Are Not So Smart:",
        "Auther":"David North",
        "Rating":"8.9/10",
        },{
        "id":3,
        "images":"https://cdn.asaha.com/assets/thumbs/436/4363a573dce18de6452986dcee9e54eb.jpg",
        "Title":"Boundaries",
        "Auther":"Henry Cloud",
        "Rating":"6.5/10",
        },{
        "id":4,
        "images":"https://cdn.asaha.com/assets/thumbs/9b8/9b88b7c17f496a61fc78505130af288e.jpg",
        "Title":"Living in the Light",
        "Rating":"8/10",
        "Auther":"Joanne RowlingDavid Sargent",
         },{
        "id":5,
        "images":"https://cdn.asaha.com/assets/thumbs/f09/f093c203496024043455817fd7a7ef3f.jpg",
        "Title":"The Purpose-Driven Life",
        "Rating":"6/10",
        "Auther":"Rick Warren",
       },{
        "id":6,
        "images":"https://cdn.asaha.com/assets/thumbs/ed5/ed59854c54d482b0efb0ee9bebbd7a72.jpg",
        "Title":"Braiding Sweetgrass",
        "Rating":"6/10",
        "Auther":"Robin",
       },{
        "id":7,
        "images":"https://cdn.asaha.com/assets/thumbs/4c9/4c902e862c6dd971cd9ff782f319dd94.jpg",
        "Title":"Just Mercy",
        "Rating":"6/10",
        "Auther":"Brayan",
       },{
        "id":8,
        "images":"https://cdn.asaha.com/assets/thumbs/cbc/cbccfdcf43fe538b39780f4f00ef21a9.jpg",
        "Title":"Napoleon",
        "Rating":"6/10",
        "Auther":"Frank",
       }]
    
  

}

export default booksdata;